import { useCallback, useEffect, useRef } from 'react';
import { createRefollowQueuePollEngine } from './refollowQueuePollCore';
import { fetchRefollowQueueShared } from './refollowQueuePollFetch';

export {
  REFOLLOW_QUEUE_POLL_MS,
  createRefollowQueuePollEngine,
  nextPollDelayMs,
  refollowQueueRequestKey,
} from './refollowQueuePollCore';
export { fetchRefollowQueueShared } from './refollowQueuePollFetch';

export function useRefollowQueuePoll({
  enabled,
  scope,
  page,
  pageSize,
  sourceBatchId,
  applyData,
  onError,
  setMemberLoading,
  loadReqRef,
  membersLoadedOnceRef,
}) {
  const engineRef = useRef(null);
  if (!engineRef.current) {
    engineRef.current = createRefollowQueuePollEngine({ fetchFn: fetchRefollowQueueShared });
  }

  const applyRef = useRef(applyData);
  applyRef.current = applyData;
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;
  const setLoadingRef = useRef(setMemberLoading);
  setLoadingRef.current = setMemberLoading;

  useEffect(() => {
    const engine = engineRef.current;
    engine.setHandlers({
      applyData: (data, opts) => applyRef.current && applyRef.current(data, opts),
      onError: (e) => onErrorRef.current && onErrorRef.current(e),
      setMemberLoading: (v) => setLoadingRef.current && setLoadingRef.current(v),
      loadReqRef,
      membersLoadedOnceRef,
    });
  });

  useEffect(() => {
    const engine = engineRef.current;
    const onVis = () => engine.onVisibilityChange();
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, []);

  useEffect(() => {
    const engine = engineRef.current;
    engine.stop();
    if (!enabled) return undefined;
    engine.start({
      enabled: true,
      scope,
      page,
      pageSize,
      sourceBatchId,
    });
    return () => engine.stop();
  }, [enabled, scope, page, pageSize, sourceBatchId]);

  return useCallback((opts) => {
    if (engineRef.current) engineRef.current.refetchNow(opts);
  }, []);
}
